var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 12,
    viewBox: "0 0 80 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-396.5,713.088h-80v-12h.988v11.04h78.025v-11.04h.988Z",
    transform: "translate(476.501 -701.088)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpace);
export default __webpack_public_path__ + "static/media/icon-space.75e96e53b1f14f9bc21b3c5e012e5ef7.svg";
export { ForwardRef as ReactComponent };